import { useDisclosure } from '@cardboard-ui/react';
import { FilePlusIcon } from 'components/icons';
import React from 'react';
import { MenuItem } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { EditorAttachmentModal } from '../toolbar/tools/attachments/EditorAttachmentModal';
import { useEditorUploader } from 'hooks/useEditorUploader';

interface AddFileBlockProps {
  pageId: string;
  pos?: number;
  setOpenDialog: (status: boolean) => void;
}

export const AddFileBlock = ({
  pageId,
  pos,
  setOpenDialog,
}: AddFileBlockProps) => {
  const {
    isOpen: isOpenFileUpload,
    onClose: onCloseFileUpload,
    onOpen: onOpenFileUpload,
  } = useDisclosure();

  const { upload } = useEditorUploader({ pageId, pos });

  return (
    <>
      <MenuItem
        icon={<FilePlusIcon />}
        onClick={() => {
          setOpenDialog(true);
          onOpenFileUpload();
        }}
      >
        {t`File`}
      </MenuItem>
      <EditorAttachmentModal
        isOpen={isOpenFileUpload}
        onClose={() => {
          setOpenDialog(false);
          onCloseFileUpload();
        }}
        onUploadFile={upload}
        pageId={pageId}
      />
    </>
  );
};
